import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getRecord, deleteRecord } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";


function DatatableTables() {
    const[alluserlist,setallusers] = useState({ users: [] });
   const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

    useEffect(()  => {
        getallusers();
    }, []);

    const getallusers = async () => {
        let response = await getRecord();
        if (response.error) {
            console.log('Error while fetching data:', response.error);      
        } else {
            setallusers({users: response.data});
            //console.log(response.data);
        }
    }
   const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsConfirmOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedDeleteId(null);
    setIsConfirmOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await deleteRecord(selectedDeleteId);
      toast.success("Record Category deleted successfully");
      getallusers();
    } catch (error) {
      toast.error("Failed to delete record");
      console.error("Delete error:", error);
    } finally {
      closeDeleteModal();
    }
  };


    const columns = useMemo(
        () => [
            {
                Header: 'Record Category',
                accessor: 'name',
            },
           
            {
                Header: "Action",
                Cell: ({ row }) => {
                  const id = row.original._id; 
                  return (
                    <>
                      <button className="btn btn-danger mx-2"
                    onClick={() => openDeleteModal(id)}
                    > <i className="mdi mdi-trash-can font-size-15"></i> </button>
                    </>
                  )
                },
              },
        ],
        []
    );
    //meta title
    document.title = "Record Category | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/Addrecord" className="btn btn-primary">ADD NEW</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Record Category" />
                <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        <Modal isOpen={isConfirmOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this record category?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
            </div>
        </div>
    );
}

export default DatatableTables;